// extracted by mini-css-extract-plugin
export default {"container":"CdtokJui4GDEm6AZtiDuuw=="};